import React, { PropTypes } from 'react';
import ReactTooltip from 'react-tooltip';
import LightBox from '../Common/LightBox';
import DetailsContent from '../Documents/DetailsContent';
import DownloadContent from '../Documents/DownloadContent';
import EditButton from './EditButton';

export default class VisibleDocuments extends React.Component {

	constructor(props) {
		super(props);
		this.state = { isModalOpen: false, details: {}, files: [], x: 0, y: 0 };
	}

	handleDetailsClick(id, e) {		
		const { clientX, clientY } = e;
		const detailsCallback = (details) => this.setState({isModalOpen: true, x: clientX, y: clientY, details});
		const filesCallback = (files) => this.setState({isModalOpen: true, x: clientX, y: clientY, files: files});
		this.props.getDocumentDetails(id, detailsCallback);
		this.props.getDocumentFiles(id, filesCallback);
	}

	getList() {
		// this.props.actions.setCurrentPage(1);
		const highlight = this.props.documents.filter((d) => this.props.selected.indexOf(d.id) > -1);
		const rest = this.props.documents.filter((d) => this.props.selected.indexOf(d.id) === -1);
		return highlight.concat(rest);
	}

	getDocuments() {
		const { isFetching, documents, selected } = this.props;
		if ( isFetching ) return <i className="fas fa-circle-notch fa-spin fa-fw" />;
		return documents.length === 0 
			? <div className="document-not-found">Nenhum documento encontrado!</div>
			: this.getList().map((d, i) => 
				<div key={i} className="document-control-item">
					<a 
						className={`pointer ${selected.indexOf(d.id) > -1 ? 'document-highlighted' : ''}`}
						onClick={this.handleDetailsClick.bind(this, d.id)}						
					>
						{d.position.length !== 0 
							? <span><i className="fa fa-map-marker" />&nbsp;</span> 
							: null}
						{d.title}
					</a>										
				</div>
			);
	}

	getResetSelection() {
		return this.props.selected.length === 0
			? null
			: (
			<span className="pull-right">
				<a className="pointer" onClick={() => this.props.resetSelection([])}>
					[ Desfazer Seleção ]
				</a>
			</span>
			);
	}

	render () {		
		return (			
			<div className="document-control-box cs-card">
				<div>
					{/* <span> */}
					<div className="row">
						<i 
							className="fa fa-caret-up fa-2x pointer col-md-6" 
							style={{margin: "auto"}} 
							data-tip="Ocultar Documentos" 
							onClick={() => {
								ReactTooltip.hide();
								this.props.onHide();
							}}
						/>
						<div className="col-md-6">

							<div style={{float: "right"}}>
								<input 
								type="checkbox" 
								style={{marginRight: "2px"}}
								onChange={(e) => this.props.setHideDocumentsFromMap(e.target.checked)} 
								checked={this.props.hideDocumentsFromMap}
								/>
								Ocultar Pontos
							</div>
							
						</div>
					{this.getResetSelection()}	
					</div>
										
					{/* </span> */}
					<hr style={{marginTop: "5px", marginBottom: "5px"}} />
					{this.getDocuments()}
					<ReactTooltip />
				</div>
				<LightBox						
					isOpen={this.state.isModalOpen}						 
					onClose={() => this.setState({isModalOpen: false})}>
					<div>
						<EditButton id={this.state.details.id} />						
						<DetailsContent details={this.state.details} />
						<DownloadContent files={this.state.files} downloadFile={this.props.downloadFile} />												
					</div>						
				</LightBox>
			</div>			
		);
	}
}

VisibleDocuments.propTypes = {
	isFetching: PropTypes.bool.isRequired,
	documents: PropTypes.array.isRequired,
	downloadFile: PropTypes.func.isRequired,
	getDocumentDetails: PropTypes.func.isRequired,
	getDocumentFiles: PropTypes.func.isRequired,
	resetSelection: PropTypes.func.isRequired,
	selected: PropTypes.array.isRequired,
	onHide: PropTypes.func.isRequired,
	hideDocumentsFromMap: PropTypes.bool.isRequired,
	setHideDocumentsFromMap: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Explorer/VisibleDocuments.js